module.exports = __webpack_public_path__ + "media/images/text_ministerio-f79349a8180f1cd69a14fe41c5e730d0.png";